
import { widget } from '../../widgets/widget-decorator';
import { BindingEngine, customElement, useView, PLATFORM, TaskQueue } from 'aurelia-framework';
import { PorfolioReportViewModel, PortfolioClient } from '../../clients/reporting-clients';
import { CustomerService } from '../../services/customer-service';
import { WidgetBase } from '../widget-base';
import { IApplicationFilter } from '../../interfaces/i-application-filter';
import { GridStack, GridStackItem } from 'aurelia-gridstack';
import { property } from '../property-decorator';

declare module '../../clients/reporting-clients' {
  interface PorfolioReportViewModel {
    estimatedProfitLossPercent?: number;
    estimatedValuePercent?: number;
  }
}

@customElement('instrument-type-info-widget')
@useView(PLATFORM.moduleName('./instrument-type-info-widget.html'))
@widget('Instrument type information', true, true)
export class InstrumentTypeInfoWidget extends WidgetBase {
  constructor(element: Element, customerSettings: CustomerService, private portfolioClient: PortfolioClient, bindingEngine: BindingEngine, private gridStackItem: GridStackItem,
    private taskQueue: TaskQueue, private gridStack: GridStack) {
    super(element, bindingEngine, customerSettings);
  }

  data: PorfolioReportViewModel[];
  widgetDiv: HTMLDivElement;
  isIgnite = this.gridStack.root.classList.contains('ignite');

  @property()
  headerFont?: string;

  @property()
  headerFontSize?: number;

  @property()
  headerColor?: string;

  @property('Text')
  font?: string;

  @property('Text')
  fontSize?: number;

  @property('Text')
  color?: string;

  override async loadData(filter: IApplicationFilter) {
    return this.portfolioClient.byType(filter.customer.companyId, filter.dates.toStr);
  }

  override async setData(data: PorfolioReportViewModel[]) {
    this.data = data;
    const { estimatedProfitLossSum, estimatedValueSum } = data.reduce((acc, curr) => {
      return {
        estimatedProfitLossSum: acc.estimatedProfitLossSum + curr.estimatedProfitLoss,
        estimatedValueSum: acc.estimatedValueSum + curr.estimatedValue
      };
    }, { estimatedProfitLossSum: 0, estimatedValueSum: 0 });
    this.data.forEach(x => {
      x.estimatedProfitLossPercent = x.estimatedProfitLoss / estimatedProfitLossSum * 100;
      x.estimatedValuePercent = x.estimatedValue / estimatedValueSum * 100;
    });
    if (!this.gridStackItem.root.classList.contains('grid-stack-item--edited') && this.gridStack.grid) {
      this.taskQueue.queueTask(() => {
        if (this.gridStackItem.root.clientHeight < this.widgetDiv.scrollHeight) {
          // set slightly larger so that there is a gap between this widget and the next one when the height is decreased
          this.gridStackItem.h += Math.ceil((this.widgetDiv.scrollHeight - this.gridStackItem.root.clientHeight)/ (this.gridStack.grid.opts.cellHeight as number)) + 2;
          this.taskQueue.queueTask(() => this.gridStackItem.h -= 2);
        }
      });
    }
  }

}
